/* global jQuery */
import slick from 'slick-carousel';
import jQuery from 'jquery';


document.addEventListener('DOMContentLoaded', function() {
  jQuery('.hero').slick({
    slidesToShow: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    mobileFirst: true
  });
});



// WEBPACK FOOTER //
// ./js/components/hero/hero.js